import React from "react";
import styles from "./styles.module.scss";

/**
 * WordLevelRenderer - Renders individual words with timestamps for precise highlighting
 * 
 * Features:
 * - Word-level highlighting during playback
 * - Click on word to jump to timestamp
 * - Visual feedback for active word
 */
export default function WordLevelRenderer({
  segment,
  words,
  currentPlayingWord,
  onWordClick,
  isSegmentSelected,
}) {
  // Filter words that belong to this segment
  const segmentWords = words.filter(
    (word) => word.start >= segment.start && word.end <= segment.end
  );
  
  // Debug: log segment info
  console.log(`Segment ${segment.id}: start=${segment.start}, end=${segment.end}, words=${segmentWords.length}, currentPlayingWord=${currentPlayingWord}`);

  
  // If no word-level data available, fallback to segment text
  if (!segmentWords || segmentWords.length === 0) {
    return <span className={styles.chunk}>{segment.text}</span>;
  }

  return (
    <span className={styles.wordLevelChunk}>
      {segmentWords.map((word) => {
        // Use global word.index for comparison with currentPlayingWord
        const isCurrentWord = currentPlayingWord !== null && currentPlayingWord === word.index;
        
        // Debug: log first few words to see what's happening
        if (word.index < 10) {
          console.log(`Word ${word.index} "${word.word}": isCurrentWord=${isCurrentWord}, currentPlayingWord=${currentPlayingWord}`);
        }
        
        return (
          <span
            key={`word-${word.index}`}
            className={`${styles.word} ${
              isCurrentWord ? styles.wordPlaying : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
            onDoubleClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              onWordClick(word.start);
            }}
            title={`Double-click to jump to ${word.start.toFixed(2)}s - ${word.end.toFixed(2)}s${word.probability ? ` (${(word.probability * 100).toFixed(1)}% confidence)` : ''}`}
          >
            {word.word}
          </span>
        );
      })}
    </span>
  );
}

